type Props = {
  className?: string
  filled: boolean
}

const HeartIcon = ({className, filled}: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='17'
      fill='none'
      viewBox='0 0 20 17'
      className={className}
    >
      {filled ? (
        <path
          fill='#FF005C'
          d='M10.01 16.71q.321 0 .645-.116a1.5 1.5 0 0 0 .57-.361l1.437-1.306a66 66 0 0 0 4.748-4.764q2.09-2.34 2.09-5.013 0-2.13-1.436-3.564Q16.629.15 14.5.15q-1.21 0-2.39.558-1.18.557-2.11 1.811Q9.07 1.265 7.89.708A5.54 5.54 0 0 0 5.5.15q-2.13 0-3.564 1.436Q.5 3.022.5 5.15q0 2.701 2.125 5.068a64 64 0 0 0 4.739 4.724l1.42 1.29q.247.247.575.362.33.115.65.115'
        />
      ) : (
        <path
          fill='#999'
          d='M10.01 16.71q.321 0 .645-.116a1.5 1.5 0 0 0 .57-.361l1.437-1.306a66 66 0 0 0 4.748-4.764q2.09-2.34 2.09-5.013 0-2.13-1.436-3.564Q16.629.15 14.5.15q-1.21 0-2.39.558-1.18.557-2.11 1.811Q9.07 1.265 7.89.708A5.54 5.54 0 0 0 5.5.15q-2.13 0-3.564 1.436Q.5 3.022.5 5.15q0 2.701 2.125 5.068a64 64 0 0 0 4.739 4.724l1.42 1.29q.247.247.575.362.33.115.65.115m.71-12.671q.81-1.237 1.708-1.813T14.5 1.65q1.5 0 2.5 1t1 2.5q0 1.204-.776 2.517a16.3 16.3 0 0 1-1.948 2.612 36 36 0 0 1-2.54 2.536q-1.367 1.239-2.534 2.302a.3.3 0 0 1-.202.077.3.3 0 0 1-.202-.077q-1.167-1.063-2.535-2.302a36 36 0 0 1-2.539-2.536 16.3 16.3 0 0 1-1.948-2.612Q2 6.354 2 5.15q0-1.5 1-2.5t2.5-1q1.175 0 2.072.576t1.709 1.813a.8.8 0 0 0 .319.288.89.89 0 0 0 .8 0 .8.8 0 0 0 .32-.288'
        />
      )}
    </svg>
  )
}

export default HeartIcon
